<template>
  <div
    v-if="show"
    class="fixed z-10 inset-0 bg-gray-900 bg-opacity-60 overflow-y-auto flex items-center justify-center text-base"
  >
    <div class="bg-white rounded-lg shadow-xl w-3/12 max-h-[90vh] overflow-y-auto">
      <div class="flex items-center justify-between p-4 border-b">
        <h4 class="text-lg text-gray-800 font-bold">Edit Facility Service</h4>
        <button
          type="button"
          class="ml-auto -mx-1.5 -my-1.5 p-1.5 inline-flex text-gray-500 items-center justify-end h-8 w-8 hover:text-custom-yellow"
          @click="$emit('close')"
          aria-label="Close"
        >
          <span class="sr-only">Dismiss</span>
          <svg
            class="w-3 h-3"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
            />
          </svg>
        </button>
      </div>
      <div class="bg-white p-8 rounded-lg shadow-md max-w-7xl mx-auto">
        <!-- <div class="grid grid-cols-4 gap-x-10 gap-y-6 flex px-20 mt-5"> -->
        <div>
          <label
            for="department"
            class="block text-sm font-medium text-gray-700"
            >Department<span class="text-red-500">*</span></label
          >
          <select
            id="department"
            v-model="newService.service_type_id"
            @change="handleServiceTypeChange()"
            class="mt-1 block w-full rounded-sm border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50 bg-gray-50"
          >
            <option
              v-for="serviceType in serviceTypes"
              :key="serviceType.id"
              :value="serviceType"
            >
              {{ serviceType.name }}
            </option>
          </select>
          <span
            class="text-xs text-red-500"
            v-if="newService.errors.service_type_id"
            >{{ newService.errors.service_type_id }}</span
          >
        </div>

        <div>
          <label
            for="serviceType"
            class="block text-sm font-medium text-gray-700"
            >Service Name<span class="text-red-500">*</span></label
          >
          <input
            type="text"
            id="genericName"
            v-model="newService.name"
            placeholder="Service Name e.g Urinalysis"
            class="mt-1 block w-full rounded-sm border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50 bg-gray-50"
          />
          <span class="text-xs text-red-500" v-if="newService.errors.name">{{
            newService.errors.name
          }}</span>
        </div>

        <div v-if="newService.show_sample">
          <label for="sample_id" class="block text-sm font-medium text-gray-700"
            >Lab Sample</label
          >
          <select
            id="sample_id"
            v-model="newService.sample_id"
            class="mt-1 block w-full rounded-sm border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50 bg-gray-50"
          >
            <option
              v-for="sample in samples"
              :key="sample.id"
              :value="sample.id"
            >
              {{ sample.name }}
            </option>
          </select>
          <span
            class="text-xs text-red-500"
            v-if="newService.errors.sample_id"
            >{{ newService.errors.sample_id }}</span
          >
        </div>

        <div>
          <label for="cost" class="block text-sm font-medium text-gray-700"
            >Cost<span class="text-red-500">*</span></label
          >
          <input
            type="number"
            id="cost"
            v-model="newService.unit_price"
            min="0.00"
            class="mt-1 block w-full rounded-sm border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50 bg-gray-50"
          />
          <span
            class="text-xs text-red-500"
            v-if="newService.errors.unit_price"
            >{{ newService.errors.unit_price }}</span
          >
        </div>

        <div v-if="newService.is_consultation">
          <label class="block text-sm font-medium text-gray-700 mt-2"
            >Doctors providing this service</label
          >
          <div
            class="mt-1 max-h-32 overflow-y-auto border border-gray-300 rounded-sm bg-gray-50 p-2 space-y-1"
          >
            <p v-if="!doctors.length" class="text-xs text-gray-500">
              No doctors found for this facility.
            </p>
            <label
              v-for="doctor in doctors"
              :key="doctor.UserId"
              class="flex items-center space-x-2 text-sm text-gray-700"
            >
              <input
                type="checkbox"
                :value="doctor.UserId"
                v-model="newService.doctor_ids"
                class="rounded border-gray-300 text-custom-yellow focus:ring-custom-yellow"
              />
              <span>{{ doctor.Username }}</span>
            </label>
          </div>
        </div>
        <!-- </div> -->
        <div class="flex bottom-2 mt-4 right-40 flex space-x-4">
          <button
            type="button"
            @click="close"
            data-modal-hide="modal"
            class="px-6 mb-4 py-2 bg-gray-200 text-gray-800 hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-opacity-50"
          >
            Cancel
          </button>
          <button
            @click="submit"
            :disabled="showLoader"
            type="button"
            class="px-6 mb-4 r-4 py-2 bg-custom-yellow text-white hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-opacity-50"
          >
            <span v-if="showLoader" class="flex items-center justify-center">
              <img :src="loaderUrl" alt="Saving..." class="w-6 h-6" />
            </span>
            <span v-else> Submit </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { initFlowbite } from "flowbite";
import loaderUrl from "@/assets/images/loader.gif";
import apiClient from "@/services/api";

export default {
  name: "EditFacilityServiceModal",
  props: {
    service: {
      type: Object,
      required: true,
      default: () => ({
        service_type_id: "",
        name: "",
        unit_price: "",
        sample_id: "",
        errors: {},
      }),
    },
    show: {
      type: Boolean,
      required: true,
    },
    serviceTypes: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      loaderUrl: loaderUrl,
      showLoader: false,
      samples: [],
      doctors: [],
      newService: {
        service_type_id: "",
        name: "",
        unit_price: "",
        sample_id: "",
        doctor_ids: [],
        is_consultation: false,
        errors: {
          service_type_id: "",
          name: "",
          unit_price: "",
          sample_id: "",
        },
      },
    };
  },
  watch: {
    service: {
      immediate: true,
      handler(service) {
        console.log("service data:", service); // Debugging: Log service to ensure it's defined
        if (service && typeof service === "object") {
          this.newService = {
            service_type_id: service.service_type || "",
            name: service.name || "",
            unit_price: service.unit_price || "",
            sample_id: service.sample_id || "",
            doctor_ids: service.doctor_ids || [],
            is_consultation: service.service_type?.code === "FST-001",
            errors: service.errors || {},
            show_sample: service.service_type?.code == "FST-002",
          };
        }
      },
    },
  },
  mounted() {
    initFlowbite();
    this.fetchLabSamples();
    this.fetchDoctors();
  },

  methods: {
    async submit() {
      this.showLoader = true;

      try {
        if (!this.validateForm()) {
          console.log("invalid", this.newService);
          return;
        }

        this.showLoader = true;

        const response = await apiClient.updateFacilityService(
          this.service.id,
          this.newService
        );
        if (response.success) {
          this.showLoader = false;
          this.$toast.success("Facility services updated successfully");
          this.$emit("close");
          this.$emit("refetch");
        } else {
          this.$toast.error("Failed to update facility services");
        }
      } catch (error) {
        this.showLoader = false;
        this.$toast.error("Failed to update facility services");
        console.log(error);
      }
    },
    async fetchLabSamples() {
      try {
        this.showLoader = true;
        const response = await apiClient.getLabSamples();
        if (response.success) {
          this.showLoader = false;
          this.samples = response.data;
        }
      } catch (error) {
        this.showLoader = false;
        this.$toast.error("Failed to unable to fetch lab samples");
        console.log(error);
      }
    },
    validateForm() {
      let isValid = true;

      if (!this.newService.service_type_id) {
        this.newService.errors.service_type_id = "Service Type is required.";
        isValid = false;
      }
      if (!this.newService.name) {
        this.newService.errors.name = "Name is required.";
        isValid = false;
      }
      if (!this.newService.unit_price || this.newService.unit_price <= 0) {
        this.newService.errors.unit_price =
          "Unit Price must be greater than 0.";
        isValid = false;
      }

      return isValid;
    },
    async fetchDoctors() {
      try {
        const response = await apiClient.fetchFacilityDoctors();
        if (response.success) {
          this.doctors = response.data;
        }
      } catch (error) {
        this.$toast.error("Failed to fetch doctors");
        console.log(error);
      }
    },
    handleServiceTypeChange() {
      if (this.newService.service_type_id?.code == "FST-OO2") {
        this.newService.show_sample = true;
      } else {
        this.newService.show_sample = false;
        this.newService.sample_id = "";
      }
      this.newService.is_consultation =
        this.newService.service_type_id?.code === "FST-001";
      if (!this.newService.is_consultation) {
        this.newService.doctor_ids = [];
      }
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
